import React, { useEffect } from "react";
import "./style.css";
import Select from "react-select";

export default function SelectComponent({
  options,
  multi,
  placeholder,
  onChange,
  defaultValues,
  noOptions,
  optionTextAlign,
  loading,
}) {
  useEffect(() => onChange(defaultValues), []);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "#681A40" : "black",
      backgroundColor: state.isSelected ? "rgba(104, 26, 64, 0.1)" : "white",
      padding: 8,
      cursor: "pointer",
      textAlign: optionTextAlign,
      "&:hover": {
        backgroundColor: "rgba(104, 26, 64, 0.2)",
        color: "#681A40",
      },
    }),
    input: (provided, state) => ({
      ...provided,
      color: "black",
    }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      color: "black",
      border: "#681A40 solid 2px",
      boxShadow: "none",
      padding: "4px",
      width: "100%",
      cursor: "pointer",
      textAlign: "left",
      "&:hover": {
        border: "#681A40 solid 2px",
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
    }),
    menuList: (provided, state) => ({
      ...provided,
      padding: "0",
      height: "auto",
      borderRadius: "4px",
    }),
    multiValue: (provided, state) => ({
      ...provided,
      border: "#33b5e5 2px solid",
      backgroundColor: "rgba(51, 182, 229, 0.1)",
      color: "#0099CC",
      borderRadius: "50px",
      padding: "0 4px",
      margin: "4px",
    }),
    multiValueLabel: (provided, state) => ({
      ...provided,
      color: "#0099CC",
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      "&:hover": {
        backgroundColor: "transparent",
        cursor: "pointer",
      },
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#681A40",
    }),
  };

  return (
    <>
      <Select
        options={options}
        isMulti={multi}
        styles={customStyles}
        className="select-component"
        placeholder={placeholder}
        input="false"
        defaultValue={defaultValues}
        noOptionsMessage={() => noOptions}
        onChange={(e) => onChange(e)}
        isLoading={loading}
      />
    </>
  );
}
